import { FC } from 'react';
import cx from 'classnames/bind';

import Cross from '@/assets/cross.svg';
import Check from '@/assets/check.svg';

import styles from './StatusIcon.module.scss';

interface StatusIconProps {
  isSuccess?: boolean;
  className?: string;
}

const cn = cx.bind(styles);

const StatusIcon: FC<StatusIconProps> = ({ isSuccess, className }) => (
  <div
    className={cn(
      'container',
      className || '',
      !isSuccess && 'container-incorrect',
    )}
  >
    <img
      className={cn('img')}
      src={isSuccess ? Check : Cross}
      alt={isSuccess ? 'Крестик' : 'Галочка'}
    />
  </div>
);

export default StatusIcon;
